import ReactECharts from "echarts-for-react";

import { useGetFarmerAnimals } from "../../features/Animals/animalApiSlice.ts";

export const OveralChart = () => {
  const { data } = useGetFarmerAnimals();

  const maleAnimals = data?.filter((animal: any) => animal.sex === "male");
  const femaleAnimals = data?.filter((animal: any) => animal.sex === "female");

  const animalsByDate: {
    [date: string]: { male: number; female: number };
  } = {};

  maleAnimals?.forEach((animal: any) => {
    const date = animal.createdAt.split("T")[0] as string;

    if (!animalsByDate[date]) {
      animalsByDate[date] = { male: 0, female: 0 };
    }
    animalsByDate[date].male++;
  });

  femaleAnimals?.forEach((animal: any) => {
    const date = animal.createdAt.split("T")[0] as string;

    if (!animalsByDate[date]) {
      animalsByDate[date] = { male: 0, female: 0 };
    }
    animalsByDate[date].female++;
  });

  const dates = Object.keys(animalsByDate).sort();
  const maleData = dates.map((date: string) => animalsByDate[date].male);
  const femaleData = dates.map((date: string) => animalsByDate[date].female);

  const option = {
    tooltip: {
      trigger: "axis",
      position: function (pt: any) {
        return [pt[0]];
      },
    },
    title: {
      left: "center",
      text: "Animals Chart",
    },
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: "none",
        },
        restore: {},
        saveAsImage: {},
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: dates,
    },
    yAxis: {
      type: "value",
      boundaryGap: [0, "100%"],
    },
    dataZoom: [
      {
        type: "inside",
        start: 0,
        end: 10,
      },
      {
        start: 0,
        end: 10,
      },
    ],
    series: [
      {
        name: "Male Animals",
        type: "line",
        symbol: "none",
        sampling: "lttb",
        itemStyle: {
          color: "rgb(255, 70, 131)",
        },
        areaStyle: {
          color: [
            {
              offset: 0,
              color: "rgb(255, 158, 68)",
            },
            {
              offset: 1,
              color: "rgb(255, 70, 131)",
            },
          ],
        },
        data: maleData,
      },
      {
        name: "Female Animals",
        type: "line",
        symbol: "none",
        sampling: "lttb",
        itemStyle: {
          color: "rgb(255, 192, 203)",
        },
        areaStyle: {
          color: [
            {
              offset: 0,
              color: "rgb(255, 218, 225)",
            },
            {
              offset: 1,
              color: "rgb(255, 192, 203)",
            },
          ],
        },
        data: femaleData,
      },
    ],
  };

  return (
    <div className={"h-full"}>
      <ReactECharts option={option} style={{ height: 500 }} />
    </div>
  );
};
